import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { CHAT_TYPE } from "sr/i18n/messages/setting";
import { getMessage } from "sr/utils/api/cleaner/getMessage";

export const fetchIndividualNotification =  createAsyncThunk('individualNotification', async (params:any)=>{
const queryParams = new URLSearchParams()
                       queryParams?.append('recipient_id', params?.userId)
                       const query = {
                        $or: [
                            { sender_id_type: "cleaner" },
                            { sender_id_type: "system" }
                        ]
                    };
                       queryParams.append('filter', JSON.stringify(query))
                        queryParams.append('limit', '1000')
                        queryParams.append('readed', 'false')
                   try {
                   const res = await getMessage(queryParams)
                   if(res?.success===true) {
                    const messages = []
                    for (let i =0; i<res?.data?.length; i++){
                      if((Object.values(CHAT_TYPE)?.includes(res?.data[i]?.type) || (res?.data[i]?.sender_id_type==='system'))){
                            messages.push(res?.data[i])
                      }

                    }
                   return messages
                   }
                   else {
                   
                   }
                   }
                   catch(e) {
                   }
})

interface initialState {
data:any,
isLoading:Boolean,
isError:Boolean
}

const initialState:initialState = {
data:null,
isLoading:false,
isError:false
}
const individualNotificationSlice = createSlice({
    name:'fetchIndividualNotification',
    initialState,
    extraReducers:(builder) =>{
        builder.addCase(fetchIndividualNotification.pending, (state, action)=> {
            state.isLoading = false
        })
        builder.addCase(fetchIndividualNotification.fulfilled, (state, action)=> {
            state.data = action.payload
        })
        builder.addCase(fetchIndividualNotification.rejected, (state, action)=> {
            state.isError = true
        })
    },
    reducers:{
        updateNotificationMessage:(state, action)=>{
            state.data = action.payload
        },
        removeNotificationMessage:(state, action)=>{
            if(action?.payload?.id){
            state.data = state?.data?.filter((item)=> item?._id !== action?.payload?.id)
        }
        else {
            state.data = []
        }
        }
    }
})
export const {updateNotificationMessage, removeNotificationMessage} = individualNotificationSlice.actions
export default individualNotificationSlice.reducer;